import { createFileRoute } from "@tanstack/react-router";
import { OrganizationEvents } from "@/components/protected/organization-events";

export const Route = createFileRoute("/_protected/admin/events")({
	component: () => <OrganizationEvents />,
});
